import React, { useContext } from "react";
import { Modal, Button } from "antd";
import ICDone from "./../../acsset/ic-done.png";


const Success = ({open, handleCancel}) => {

  const css = {
    divButton: {
      display: "flex",
      justifyContent: "space-around",
      marginTop: "15px",
      alignItems: "center",
    },
    button: {
      width: "100%",
      height: 40,
      borderRadius: 7,
      background: "#F0F2F5",
      borderColor: "#F0F2F5",
      color: "#343A40",
      fontWeight: 600,
      fontSize: 15
    },
  };
  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        style={{
          margin: 0,
          padding: 0,
          maxWidth:'325px'
        }}
        className="modal-custom"
        centered={true}
        footer={false}
        open={true}
        closable={false}
        maskStyle={{ background: "#000000", opacity: 0.8 }}
      >
        <div style={{ textAlign: "center" }}>
          <img src={ICDone} style={{ width: "60px" }} />
          <div
            style={{
              fontSize: 18,
              marginTop: 10,
              fontWeight: 600,
              color: "#343A40",
            }}
          >
            Bạn đã chụp hình xe thành công
          </div>
          <div style={css.divButton}>
            <Button onClick={() => {
              window.location.reload();
              handleCancel();
              }} style={css.button}>
              <div style={{fontSize: 15}}>Đóng</div>
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Success;
